import { Component } from '@angular/core';
import { StatusCardConfig } from '@shared/components/widgets/status-card/status-card-config';
import { DashboardService } from '@app/api/dmc';
import { ConnectionPointService } from '@app/api/nts';
import { StatusCardComponent } from '@shared/components/widgets/status-card/status-card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ODataService } from '@app/core/services/odata/odata.service';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard-maalepunkter',
  imports: [
    StatusCardComponent,
    TranslatePipe,
  ],
  templateUrl: './dashboard-maalepunkter.component.html',
})
export class DashboardMaalepunkterComponent {

  public meteringPointProductionObligation: StatusCardConfig = {
    label: 'dashboard.query.querychangestoproductionobligation',
    route: ['/dashboard', 'query', 'changestoproductionobligation'],
    serviceCallback: () => this.dashboardService.dashboardGetChangesToProductionObligationGet(),
  };

  public meteringPointWithSupplier: StatusCardConfig = {
    label: 'dashboard.query.querynewmeteringpointwithsupplier',
    route: ['/dashboard', 'query', 'newmeteringpointwithsupplier'],
    serviceCallback: () => this.dashboardService.dashboardGetNewMeteringPointsWithSupplierGet(),
  };

  public meteringPointChargeInformationRejected: StatusCardConfig = {
    label: 'dashboard.query.querymeteringpointchargeinformationrejected',
    route: ['/dashboard', 'query', 'meteringpointchargeinformationrejected'],
    serviceCallback: () => this.dashboardService.dashboardGetMeteringPointsChargeInformationRejectedGet(),
  };

  public meteringPointChargeInformationPending: StatusCardConfig = {
    label: 'dashboard.query.querymeteringpointchargeinformationpending',
    route: ['/dashboard', 'query', 'meteringpointchargeinformationpending'],
    serviceCallback: () => this.dashboardService.dashboardGetMeteringPointsChargeInformationPendingGet(),
  };

  public meteringPointOverduePending: StatusCardConfig = {
    label: 'dashboard.query.querymeteringpointsoverduepending',
    route: ['/dashboard', 'query', 'meteringpointsoverduepending'],
    serviceCallback: () => this.dashboardService.dashboardGetMeteringPointsOverduePendingGet(),
  };

  public meteringPointRejectedByDataHub: StatusCardConfig = {
    label: 'dashboard.query.rejectedmeteringpoints.title',
    route: ['/dashboard', 'query', 'rejectedmeteringpoints'],
    serviceCallback: () => this.dashboardService.dashboardGetMeteringPointsRejectedByDataHubGet(),
  };

  public meteringPointGhostMeters: StatusCardConfig = {
    label: 'dashboard.query.queryghostmeters',
    route: ['/dashboard', 'query', 'ghostmeters'],
    serviceCallback: () => this.dashboardService.dashboardGetGhostMetersGet(),
  };

  public meteringPointNotInDHM: StatusCardConfig = {
    label: 'dashboard.query.querymetersnotindhm',
    route: ['/dashboard', 'query', 'notindhm'],
    serviceCallback: () => this.dashboardService.dashboardGetMeteringPointsNotInDHMGet(),
  };

  public meteringPointMetersNotConnected: StatusCardConfig = {
    label: 'dashboard.query.querymetersnotconnected',
    route: ['/dashboard', 'query', 'metersnotconnected'],
    serviceCallback: () => this.dashboardService.dashboardActiveMetersNotConnectedToMeterFrameGet(),
  };

  /** Datakonsistens **/
  public meteringPointWithoutRelations: StatusCardConfig = {
    label: 'dashboard.query.withoutrelations.title',
    route: ['/dashboard', 'query', 'withoutrelations'],
    serviceCallback: () => this.dashboardService.dashboardGetMeteringPointsWithoutRelationsGet(),
  };

  public meteringPointQuadrantMismatch: StatusCardConfig = {
    label: 'dashboard.query.querymeteringpointquadrantmismatch',
    route: ['/dashboard', 'timeseries', 'quadrantmismatch'],
    serviceCallback: () => this.oDataService.dmc.getCount(ODataType.meteringPointQuadrantMismatch).pipe(map(count => ({ totalHitCount: count }))),
  };

  public expiringConnectionRights: StatusCardConfig = {
    label: 'dashboard.connectionright.expiring.title',
    route: ['/dashboard', 'query', 'expiringconnectionrights'],
    serviceCallback: () => this.connectionPointService
      .connectionPointConnectionRightsExpiringPost({ page: 1, pageSize: 1 }),
  };

  /** Elvarme **/
  public electricalHeatingCreate: StatusCardConfig = {
    label: 'dashboard.query.missingelectricalheating.title',
    route: ['/dashboard', 'query', 'missingelectricalheating'],
    serviceCallback: () => this.dashboardService.dashboardGetMissingElectricalHeatingGet(),
  };

  public electricalHeatingRemove: StatusCardConfig = {
    label: 'dashboard.query.removalelectricalheating.title',
    route: ['/dashboard', 'query', 'removalelectricalheating'],
    serviceCallback: () => this.dashboardService.dashboardGetRemovalOfElectricalHeatingGet(),
  };

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly oDataService: ODataService,
    private readonly connectionPointService: ConnectionPointService,
  ) {}
}
